import Client from "./Kumosearch/Client";
import SearchClient from "./Kumosearch/SearchClient";
import * as Errors from "./Kumosearch/Errors";

export { Client, SearchClient, Errors };
export default { Client, SearchClient, Errors };
